"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { captureCheckoutAttributionFromLocation } from "@/utils/ads/checkout-attribution";
import { captureSignupAttribution } from "@/utils/ads/signup-attribution";

export default function AttributionCapture() {
  const pathname = usePathname();
  const search = useSearchParams().toString();
  useEffect(() => {
    captureSignupAttribution();
    captureCheckoutAttributionFromLocation();
  }, [pathname, search]);

  return null;
}
